<template>
  <div class="wrapper">
    <jm-crumbs/>
    <el-form
      ref="form"
      :inline="true"
      label-width="80px">
      <el-row>
        <el-form-item label="电话">
          <el-input v-model.trim="searchData.phone"/>
        </el-form-item>
        <el-form-item label="QQ">
          <el-input v-model.trim="searchData.qq"/>
        </el-form-item>
        <el-form-item label="微信">
          <el-input v-model.trim="searchData.wechat"/>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="电话">
          <el-input v-model.trim="searchData.phone_other"/>
        </el-form-item>
        <el-form-item label="QQ">
          <el-input v-model.trim="searchData.qq_other"/>
        </el-form-item>
        <el-form-item label="微信">
          <el-input v-model.trim="searchData.wechat_other"/>
        </el-form-item>
        <el-button
          type="primary"
          v-if="canSearch"
          @click="doSearch">搜索</el-button>
      </el-row>
    </el-form>
    <jm-table-list
      v-if="canSearch"
      ref="stable"
      url="/index/student/mergeUserList"
      :search-data="searchData"
      row-key="id"
    >
      <el-table-column
        slot="firstColumn"
        width="150"
        label="是否绑定APP">
        <template slot-scope="scope">
          <el-tag
            v-if="(students[`${scope.row.id}`] = scope.row.userid) || true"
            :key="scope.row.id"
            :type="scope.row.userid ? 'success': 'info'">
            {{ scope.row.userid ? `已绑定${scope.row.userid}`: '未绑定' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        slot="lastColumn"
        label="操作"
        :width="180">
        <template slot-scope="scope">
          <el-switch
            v-model="live[`s_${scope.row.id}`]"
            active-text="保留"
            inactive-text="不保留"
            :active-value="scope.row.id"
            :inactive-value="0"
            @change="changeResourceStatus"
          />
        </template>
      </el-table-column>
    </jm-table-list>
    <el-button
      type="primary"
      @click="changeBinding">换绑</el-button>
  </div>
</template>

<script>

import jmTableList from '@/components/data/tableList';

export default {
  components: {
    jmTableList,
  },
  data() {
    return {
      live: {},
      students: {},
      searchData: {
        phone: null,
        wechat: null,
        qq: null,
        phone_other: null,
        wechat_other: null,
        qq_other: null,
      }
    };
  },
  computed: {
    canSearch() {
      return Object.values(this.searchData).some((item) => {
        return !!item;
      });
    },
  },
  methods: {
    doSearch() {
      this.live = {};
      this.$refs.stable.doSearch();
    },
    changeBinding() {
      if (Object.keys(this.students).length !== 2) {
        this.$message({
          message: '数据不是两条。无法换绑',
          type: 'warning'
        });
        return false;
      }

      this.$confirm('确定要进行换绑吗？?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const keys = Object.keys(this.students);
        const temp = this.students[keys[1]] || 0;
        let data = {
          resource: {
            [keys[1]]: this.students[keys[0]] || 0,
            [keys[0]]: temp
          }
        };
        this.$http._post({
          url: '/index/student/changeBinding',
          data
        }).then(() => {
          this.doSearch();
        });
      });
    },
    changeResourceStatus(val) {
      Object.keys(this.live).forEach((item) => {
        console.log(item);
        let key = `s_${val}`;
        if (item !== key) {
          // this.live[key] = 0;
        }
      });
    }
  },
};
</script>
